import api from '@/api';

const { $commission, $pricing, $core, $academic, $report} = api;
export const { $payings, $sellers } = $commission;
export const { $sellersReporting, $student } = $report;
export const { $terms, $careers } = $academic;
export const { $types } = $pricing
export const { $users } = $core
